/**
 * SearchInput Component:
 * Reusable input field component for search functionality.
 * Props:
 *   - name: The name attribute for the input field.
 *   - id: The id attribute for the input field.
 *   - value: The current value of the input field.
 *   - placeholder: The placeholder text for the input field.
 *   - className: Additional CSS classes for styling the input field.
 *   - onKeyDown: Function to handle key down events on the input field.
 *   - onChange: Function to handle change events on the input field.
 */
import React from "react";
// External dependencies
import classNames from "classnames";
interface SearchInputProps {
  name?: string;
  id?: string;
  value: string;
  placeholder?: string;
  className?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const SearchInput: React.FC<SearchInputProps> = ({
  name,
  id,
  value,
  placeholder,
  className,
  onKeyDown,
  onChange,
  ...props
}) => {
  // Combining default and additional classes for the input classes
  const inputClasses = classNames(
    "form-control",
    "form-control-sm",
    "m-input",
    "search-icons",
    className
  );
  return (
    <>
      <input
        type="text"
        className={inputClasses}
        name={name}
        placeholder={placeholder}
        id={id}
        value={value}
        onKeyDown={(e) => onKeyDown?.(e)}
        onChange={(e) => onChange(e)}
        {...props}
      />
    </>
  );
};

export default SearchInput;
